import { render, staticRenderFns } from "./ViewData.vue?vue&type=template&id=98da4f5e&"
import script from "./ViewData.vue?vue&type=script&lang=js&"
export * from "./ViewData.vue?vue&type=script&lang=js&"
import style0 from "./ViewData.vue?vue&type=style&index=0&id=98da4f5e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports